import React from "react";
import "./Spinner.css";
import { withRouter } from "react-router-dom";
const Spinner = (props) => {
  return (
    <div id = "overlaySpinner">
      <div className="spinner text-center"></div>
    </div>
  );
};

export default withRouter(Spinner);
